import { getDomainKeySelect } from "./verify-domain";

export const isMaisAgilDomain = () => getDomainKeySelect() === "maisagil";
